module.exports = __webpack_public_path__ + "static/media/favor_gray.21bf8d2f.svg";